{
  "eyebrow": "Opprett kontoen din",
  "title": "Noen detaljer om bedriften din.",
  "sub": "Du blir hovedadministrator. Du kan invitere flere administratorer etter oppsett.",
  "company": "Bedrift",
  "companyName": "Bedriftsnavn",
  "companyVat": "MVA-nummer",
  "companyVatBssHint": "Påkrevd for rapportering til belgisk trygd (DIMONA).",
  "companyCountry": "Land",
  "admin": "Hovedadministrator",
  "adminFirst": "Fornavn",
  "adminLast": "Etternavn",
  "adminEmail": "Jobb-e-post",
  "adminPhone": "Telefon",
  "adminPw": "Passord",
  "adminPwHint": "Minst 10 tegn, ett tall.",
  "adminPwShow": "Vis passord",
  "adminPwHide": "Skjul passord",
  "terms": {
    "pre": "Jeg godtar",
    "t": "Vilkårene",
    "and": "og",
    "p": "Personvernerklæringen"
  },
  "cta": "Opprett konto og fortsett",
  "errors": {
    "required": "Påkrevd",
    "tooShort": "For kort",
    "invalidEmail": "Skriv inn en gyldig e-post",
    "invalidVat": "Skriv inn et gyldig MVA-nummer",
    "invalidBelgianVat": "Skriv inn et gyldig belgisk MVA-nummer (f.eks. BE0123456789).",
    "invalidPhone": "Skriv inn et gyldig telefonnummer",
    "passwordWeak": "Minst 12 tegn med ett tall",
    "termsRequired": "Du må godta vilkårene",
    "emailExists": "Denne e-posten er allerede i bruk",
    "vatRequiredForBss": "MVA-nummer er påkrevd for belgisk trygd",
    "network": "Nettverks- eller serverfeil. Prøv igjen.",
    "throttled": "For mange forsøk. Prøv igjen om {{minutes}} min."
  },
  "verify": {
    "awaitingTitle": "Sjekk innboksen",
    "awaitingSub": "Vi har sendt en bekreftelseslenke til {{email}}. Klikk på den for å aktivere kontoen din og starte den gratis prøveperioden.",
    "awaitingSubNoEmail": "Vi har sendt deg en bekreftelseslenke. Klikk på den for å aktivere kontoen din og starte den gratis prøveperioden.",
    "resend": "Send e-post på nytt",
    "resendCooldown": "Send på nytt om {{seconds}}s",
    "verifyingTitle": "Verifiserer…",
    "successTitle": "Din gratis 30-dagers prøveperiode har startet!",
    "successSub": "Ingen kredittkort nødvendig. Logg inn på dashbordet ditt for å begynne å bruke Done-it.",
    "errorTitle": "Vi kunne ikke verifisere lenken",
    "errorSub": "Lenken kan ha utløpt. Start på nytt fra kontodetaljene.",
    "errorCta": "Tilbake til kontoen",
    "interstitial": "E-postbekreftelse",
    "subscribedTitle": "Kontoen din er klar",
    "subscribedSub": "Betalingen er allerede fullført. Logg inn på dashbordet for å komme i gang med Done-it.",
    "subscribedCta": "Logg på dashbordet",
    "successCta": "Åpne dashbordet",
    "successNote": "Du får noen nyttige e-poster i løpet av prøveperioden, og en lenke for å abonnere mot slutten.",
    "awaitingSubFree": "Vi sendte en bekreftelseslenke til {{email}}. Klikk på den for å aktivere den gratis kontoen din — Time Zero er gratis for alltid, uten kredittkort.",
    "awaitingSubFreeNoEmail": "Vi har sendt deg en bekreftelseslenke. Klikk på den for å aktivere den gratis kontoen din — Time Zero er gratis for alltid, uten kredittkort.",
    "successTitleFree": "Den gratis kontoen din er klar!",
    "successNoteFree": "Time Zero er gratis for alltid innenfor grensene. Oppgrader når som helst for ubegrenset bruk."
  }
}
